import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_7: FaireProductEntity = {
  token: "catalog_prod_prod-7",
  type: "product",
  name: "Cake Stand - Ceramic Swirl",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 10.33,
  msrpDollars: 25.83,
  sku: "CO0007",
  caseSize: 4,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_makeup"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 46,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
